export enum HeadMenuItems {
	MAIN = 'main',
	REQUESTS = 'requests',
	SERVER = 'server',
	ADMIN_CHAT = 'admin_chat',
	BANS = 'bans',
	ANTICHEAT = 'anticheat',
}

export const HEAD_MENU_ITEMS: Record<HeadMenuItems, string> = {
	[HeadMenuItems.MAIN]: 'Главная',
	[HeadMenuItems.REQUESTS]: 'Запросы',
	[HeadMenuItems.SERVER]: 'Сервер',
	[HeadMenuItems.ADMIN_CHAT]: 'Админ чат',
	[HeadMenuItems.BANS]: 'Баны',
	[HeadMenuItems.ANTICHEAT]: 'Античит',
};

export const ENABLED_HEAD_MENU_ITEMS: HeadMenuItems[] = [
	HeadMenuItems.REQUESTS,
	HeadMenuItems.ANTICHEAT,
];
